import _ from 'lodash';
import axios from 'axios';
import config from '../config/config';
import { vsprintf } from 'sprintf-js';
import { APIException } from '../handlers/Exception';

class Interface {
    tokenMounted = false;

    constructor(token){
        this.config = (!!config.api.env[process.env.NODE_ENV] && !!config.api.profiles[config.api.env[process.env.NODE_ENV]]) ?
            config.api.profiles[config.api.env[process.env.NODE_ENV]] :
            config.api.profiles["_"];

        if(!!token){
            axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}
            this.tokenMounted = true;
        }
    }

    _actions = {
        get: { method: 'GET' },
        post: { method: 'POST' },
        put: { method: 'PUT' },
        delete: { method: 'DELETE' }
    };

    execute(action, endpoint, customParams, token, context) {
        let self = context || this;

        if(!self._actions[action]){
            return Promise.reject('The requested action is not defined: ' + action);
        }

        let command = _.extend(_.extend({}, self._actions[action]), _.pick(self.config, 'url') );
        command.url = command.url + vsprintf(endpoint.url,endpoint.params);

        if(customParams) command.data = customParams;

        if(!!token && !this.tokenMounted) command.headers = { Authorization: `Bearer ${token}` }

        return axios(command)
            .then(callbackSuccess)
            .catch(callbackReject);


        // ---------------------------------
        function callbackSuccess(outcome) {
            if(!!outcome.code && outcome.code > 1){
                var err = new APIException(outcome.message);
                return Promise.reject(err);
            }

            return Promise.resolve(outcome.data);
        }
        function callbackReject(error){
            var err = new APIException(error);
            return Promise.reject(err);
        }
    }

    get(endpoint, customParams){
        return this.execute('get',endpoint, customParams, this);
    }
    post(endpoint, customParams){
        return this.execute('post',endpoint, customParams, this);
    }
    put(endpoint, customParams){
        return this.execute('put',endpoint, customParams, this);
    }
    delete(endpoint, customParams){
        return this.execute('delete',endpoint, customParams, this);
    }
    getApiConfig(){
        return this.config;
    }
}

export default Interface;